/**
 * MsgSkeleton — static (no shimmer) muted grey placeholder bubbles
 * shown during chat-switch for ~150ms until the first real message
 * paints. Matches `.chat-view__msg` shape so the layout doesn't jump.
 *
 * Palette rule: 1 grey + 1 clay; we only use the muted-surface grey
 * here (no shimmer keyframe, no white highlight band).
 */

interface SkeletonOpts {
  rows?: number;
}

function bar(widthPct: number): HTMLElement {
  const el = document.createElement("div");
  el.className = "chat-view__skel-bar";
  el.style.width = `${widthPct}%`;
  return el;
}

function buildOtherBlock(): HTMLElement {
  const wrap = document.createElement("div");
  wrap.className = "chat-view__msg chat-view__msg--other chat-view__skel";

  const head = document.createElement("div");
  head.className = "chat-view__msg-head";
  head.appendChild(bar(22));
  wrap.appendChild(head);

  const text = document.createElement("div");
  text.className = "chat-view__skel-stack";
  text.appendChild(bar(92));
  text.appendChild(bar(78));
  text.appendChild(bar(54));
  wrap.appendChild(text);
  return wrap;
}

function buildSelfBlock(): HTMLElement {
  const wrap = document.createElement("div");
  wrap.className = "chat-view__msg chat-view__msg--self chat-view__skel";
  const card = document.createElement("div");
  card.className = "chat-view__skel-bubble";
  card.appendChild(bar(82));
  card.appendChild(bar(62));
  wrap.appendChild(card);
  return wrap;
}

/** Build a stack of N skeleton bubbles (default 3, alternating sides). */
export function MsgSkeleton({ rows = 3 }: SkeletonOpts = {}): HTMLElement {
  const root = document.createElement("div");
  root.className = "chat-view__skel-wrap";
  root.setAttribute("aria-hidden", "true");
  for (let i = 0; i < rows; i++) {
    root.appendChild(i % 2 === 0 ? buildOtherBlock() : buildSelfBlock());
  }
  return root;
}

export default MsgSkeleton;
